import { QuestionBase } from './question-base';

/*

Sample:

new TextboxQuestion({
  key: 'name',
  label: 'nouns.name',
  // value: 'Peter',
  required: true,
  order: 1
}),

*/
export class TextboxQuestion extends QuestionBase<string> {
  controlType = 'textbox';

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
  }
}
